import { render, staticRenderFns } from "./EmailSenderDetails.vue?vue&type=template&id=f63067f0&"
import script from "./EmailSenderDetails.vue?vue&type=script&lang=js&"
export * from "./EmailSenderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f63067f0')) {
      api.createRecord('f63067f0', component.options)
    } else {
      api.reload('f63067f0', component.options)
    }
    module.hot.accept("./EmailSenderDetails.vue?vue&type=template&id=f63067f0&", function () {
      api.rerender('f63067f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/email/EmailSenderDetails.vue"
export default component.exports